import { useEffect, useRef, useState } from 'react';
import bannerImage from '../assets/img/gallery/ch2.jpeg';
import heroBg from '../assets/img/ic_our_service_background.png';
import icIntegrity from '../assets/img/ic_integrity.png';
import icExcellence from '../assets/img/ic_excellence.png';
import icGlobalVision from '../assets/img/ic_global_vision.png';
import icVision from '../assets/img/ic_vision.png';
import PageHero from '../components/PageHero';
import { heroSubtitleClass, heroTitleClass, motionSafe } from '../constants/heroTypography';

function ValueIcon({ src, alt }) {
  return <img src={src} alt={alt} className="h-[92px] w-[92px] object-contain p-2" />;
}

export default function About() {
  const valuesRef = useRef(null);
  const [valuesInView, setValuesInView] = useState(false);

  useEffect(() => {
    const el = valuesRef.current;
    if (!el) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      setValuesInView(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setValuesInView(true);
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-navy-950">
      <PageHero
        title="About Us"
        subtitle="Learn about our story, our approach, and the values that guide every service we deliver."
        backgroundImage={heroBg}
        titleClassName={heroTitleClass}
        subtitleClassName={heroSubtitleClass(motionSafe)}
      />

      <div className="mx-auto max-w-7xl px-4 pb-20 pt-12 sm:px-6 lg:px-8 lg:pb-28">

        {/* Story */}
        <div className="mt-10 grid items-start gap-8 md:grid-cols-2 md:gap-12">
          <div>

          <h2 className="font-sans text-xl font-semibold tracking-tight text-white sm:text-2xl">
          Chairman’s Message
            </h2>
            <p className="mt-4 text-justify text-base leading-relaxed text-white/80">
            At RAYAN STAR, we are committed to delivering quality, trust, and excellence in every service we provide. Our vision is to become a leading service provider in the region by creating value for our clients and building strong, long-term relationships.
            With over 30 years of business experience across Saudi Arabia, Bahrain, UAE, and India, we understand the importance of professionalism, reliability, and customer satisfaction. Our experience across different sectors has helped us build a strong foundation to serve clients in tourism, holiday packages, destination weddings, chauffer services, education, healthcare, trading and other allied industries.
            We believe that success comes through dedication, innovation, and teamwork. At RAYAN STAR, we continuously strive to improve our services, expand our capabilities, and meet the changing needs of our clients.
            On behalf of the entire team, I would like to thank our clients, partners, and stakeholders for their trust and support. We look forward to growing together and achieving greater success in the future.
            </p>

            <p className="mt-6 text-sm leading-relaxed text-white/80">
              Warm regards,
              <br />
              <br />
              <span className="font-semibold text-white">Mr. Abdul Salam</span>
              <br />
              Founder &amp; Managing Director
              <br />
              RAYAN STAR Consultancy &amp; Services W.L.L.
            </p>

            
            

         
          </div>

          <div className="overflow-hidden rounded-[22px]">
            <img
              src={bannerImage}
              alt="Manama skyline at night"
              className="h-[380px] w-full object-cover sm:h-[680px]"
            />
          </div>
        </div>


           <br/>
            <div className="text-center">
            <p className="text-sm font-semibold tracking-[0.35em] text-white/70 sm:text-base">
              <span className="text-white">RAYAN STAR</span> <span className="text-gold">Story</span>
            </p>
            <div className="mx-auto mt-3 h-px w-16 bg-gradient-to-r from-transparent via-gold/80 to-transparent" />
          </div>

            <p className="mt-4 text-justify text-base leading-relaxed text-white/80">
              RAYAN STAR CONSULTANCY &amp; SERVICES W.L.L., established in August 2015 in Manama, Bahrain,
              is a fast-growing consultancy driven by expertise, professionalism, and ambition. Although
              a young company, we are backed by a team of highly experienced professionals with decades of
              combined experience in government documentation, education consultancy, travel &amp; tourism,
              visa services, and event management.
            </p>

            <p className="mt-4 text-justify text-base leading-relaxed text-white/80">
              We are committed to providing seamless, reliable, and client-focused solutions that simplify
              complex processes and save time for individuals, families, and businesses a like. Our goal is
              to empower our clients to achieve their personal, educational, and professional ambitions through
              efficient services and global reach.
            </p>

            <p className="mt-4 text-justify text-base leading-relaxed text-white/80">
            At RAYAN STAR, we combine deep industry knowledge with innovative approaches, ensuring every client receives personalized guidance and support. Whether it’s navigating government documentation, securing study or work visas abroad, planning international travel, or organizing impactful events, we are dedicated to turning your goals into reality.
            </p>


            

        {/* Values */}
        <div ref={valuesRef} className="mt-14">
          <div className="text-center">
            <p className="text-sm font-semibold tracking-[0.35em] text-white/70 sm:text-base">
              <span className="text-white">Our</span> <span className="text-gold">Promies</span>
            </p>
            <div className="mx-auto mt-3 h-px w-16 bg-gradient-to-r from-transparent via-gold/80 to-transparent" />
          </div>


          <div className="mt-10 grid gap-6 md:grid-cols-2">
            {[
              {
                title: 'Integrity',
                iconSrc: icIntegrity,
                text: 'Conducting business with honesty and transparency in every interaction.',
              },
              {
                title: 'Excellence',
                iconSrc: icExcellence,
                text: 'Professional standards in every task we undertake—always delivery-focused.',
              },
              {
                title: 'Global Vision',
                iconSrc: icGlobalVision,
                text: 'Expanding our reach and knowledge to serve clients worldwide.',
              },
              {
                title: 'Client-Centric Approach',
                // Closest available asset in your folder
                iconSrc: icVision,
                text: 'Your ambitions are our priority—personalized guidance and dependable support.',
              },
            ].map((v, i) => (
              <div
                key={v.title}
                className={`group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 shadow-md ${
                  valuesInView ? 'animate-fade-in-up opacity-100' : 'opacity-0'
                } motion-reduce:animate-none motion-reduce:opacity-100`}
                style={
                  valuesInView
                    ? {
                        animationDelay: `${120 + i * 95}ms`,
                      }
                    : undefined
                }
              >
                <div
                  className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                  style={{
                    background:
                      'radial-gradient(520px 260px at 50% 10%, rgba(212,175,55,0.14), transparent 60%)',
                  }}
                  aria-hidden
                />
                <div className="relative mx-auto flex h-[92px] w-[92px] items-center justify-center rounded-2xl bg-gold/10 ring-1 ring-gold/30 shadow-sm">
                  <ValueIcon src={v.iconSrc} alt="" />
                </div>
                <h3 className="mt-4 text-center font-serif text-lg font-semibold text-gold">{v.title}</h3>
                <p className="mt-3 text-center text-sm leading-relaxed text-navy/70">{v.text}</p>
              </div>
            ))}
          </div>

          <p
            className={`mx-auto mt-4 max-w-3xl text-center text-base leading-relaxed text-white/70 sm:whitespace-nowrap ${
              valuesInView ? 'animate-fade-in-up opacity-100' : 'opacity-0'
            } motion-reduce:animate-none motion-reduce:opacity-100`}
            style={valuesInView ? { animationDelay: '80ms' } : undefined}
          >
            {`With RAYAN STAR Consultancy, ambition is not just a word — it’s the foundation of everything we do.`}
          </p>
          
        </div>
      </div>
    </div>
  );
}
